import { Layout, Alert, Flex, Typography, AlertProps, Spin } from "antd";
import "../styles/consultComplete.scss"
import { useState } from "react";

const { Header, Content, Footer } = Layout
const { Text, Title } = Typography

const CloseTab = () => {
    const [title] = useState("Close This Tab")
    const [alertMessage] = useState<AlertProps>({
        message: "Duplicate Attendance Removed",
        description: "Please close this tab and navigate to your existing Telehealth window.",
        type: "info",
    })

    return (
        <Flex gap="middle" wrap>
            <Layout>
                <Header />
                <div className="complete_container">
                    <Content>
                        <div className="title_container">
                            <Title level={2}>{title}</Title>
                            {alertMessage.type === "info" &&
                                <Text>You can now exit this window, thank you.</Text>
                            }
                            {alertMessage.type === "warning" &&
                                <Spin />
                            }
                        </div>
                        <div className="info_container">
                            <Alert
                                showIcon
                                style={{ justifyContent: 'flex-start', alignItems: 'flex-start', textAlign: 'left' }}
                                type={alertMessage.type}
                                message={alertMessage.message}
                                description={alertMessage.description}
                            />
                        </div>
                    </Content>
                </div>
                <Footer />
            </Layout>
        </Flex>
    )
}

export default CloseTab 